import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import faker from '@faker-js/faker';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

export const options = {
  elements: {
    point:{
        radius: 0
    }
      },
  maintainAspectRatio: false,
  scales: {
    y: {
      display: false,
    },
    x:{
      display: false
    }
  },
  responsive: true,
  labels: {
    display: false
  },
  plugins: {
    legend: {
      display: false,
    },        
    title: {
      display: false,
      text: 'System Usage',
    },
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const data = {
  labels,
  datasets: [
    {
      fill: true,
      label: 'CPU',
      data: [50, 49, 48, 48, 50, 47, 40],
      borderColor: 'rgba(186,31,25,255)',
      backgroundColor: 'rgba(186,31,25,0.2)',
      borderWidth: 2,
    },
  ],
};

const ChartDeathsNums = () => {
  return (
    <div style={{width: "150px", height: "40px"}}>
        <Line options={options} data={data} />
    </div>
  )
}

export default ChartDeathsNums